import React, { useState } from 'react';
import MessageList from '../MessagesList';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { sendMessage } from '../../services/followup';
import {
  dangerNotification,
  successNotification,
  warningNotification
} from '../../services/notification';
import { get } from '../../services/storage';
import Button from '../Button';
import FollowUpRewriteActions from '../FollowUpRewriteActions';
import FollowUpQuillToolbar, {
  useFollowUpQuillToolbarId
} from '../FollowUpQuillToolbar';
import { FaFire } from 'react-icons/fa';
import ClaimFollowUpPendencyFields, {
  ClaimPendencyValues
} from '../ClaimFollowUpPendencyFields';
import { UserRolesEnum } from '../../enums/user-roles.enum';

import { MessageContainer, MessageBlockContainer, MessageBlockTitle } from './styles';

const MessageSender = (props: any) => {
  const { id } = props;
  const accentColor = props.accentColor || '#5C6BC0';
  const user_id = String(get('uid'));
  const user_name = String(get('name'));
  const userRole = get('role');
  const canManagePendencyFields =
    userRole === UserRolesEnum.brokerAdmin || userRole === UserRolesEnum.brokerAnalyst;
  const showPendencyFields = Boolean(props.showPendingFields && canManagePendencyFields);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [tempMessages, setTempMessages] = useState<any[]>([]);
  const [pendency, setPendency] = useState<ClaimPendencyValues>({});

  const handleSubmit = async () => {
    if (!message.trim()) {
      warningNotification('Oops...', 'Por favor, digite uma mensagem antes de enviar.');
    } else {
      try {
        setLoading(true);
        const sentMessage = await sendMessage(id, user_id, message, user_name, pendency);
        setTempMessages([...tempMessages, sentMessage]);
        setPendency({});
        successNotification('Sucesso!', 'Mensagem enviada!');
      } catch (error) {

        const err = error as { statusCode?: number; message?: string };
        console.log('ERRO AO ENVIAR MENSAGEM:', err);

        if (
          err.statusCode === 403 &&
          err.message ===
          'Esse sinistro foi finalizado, Se precisar de ajuda, entre em contato com LadoBom em sinistro.fianca@ladobom.com'
        ) {
          warningNotification('Mensagem não salva', err.message);
          if (props.onClaimFinalized) {
            props.onClaimFinalized();
          }
          return;
        }

        dangerNotification(
          'Oops...',
          'Não foi possível enviar a mensagem, tente novamente mais tarde.'
        );
      } finally {
        setMessage('');
        setLoading(false);
      }
    }
  };

  const MessageBlocked = () => {
    return (
      <MessageBlockContainer>
        <MessageBlockTitle>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginRight: '3px'
            }}
          >
            <FaFire />
          </div>
          Sinistro finalizado
        </MessageBlockTitle>
        <div>
          O sinistro já está finalizado e não é possível enviar novas mensagens, mas você
          ainda pode consultar os registros anteriores.
        </div>
        <div>
          Se precisar de ajuda, entre em contato com LadoBom em
          sinistro.fianca@ladobom.com
        </div>
      </MessageBlockContainer>
    );
  };

  const toolbarId = useFollowUpQuillToolbarId();
  const modules = {
    toolbar: {
      container: `#${toolbarId}`
    }
  };

  return (
    <>
      {props.isBlocked ? (
        <MessageBlocked />
      ) : (
        <MessageContainer
          $withBottomDivider={props.showComposerDivider}
          $compactEditor={showPendencyFields}
        >
          <div className="quilljs">
            <FollowUpQuillToolbar id={toolbarId}>
              <FollowUpRewriteActions
                message={message}
                onChange={setMessage}
                context="CLAIMS"
                disabled={loading || props.isBlocked}
              />
            </FollowUpQuillToolbar>
            <ReactQuill
              theme="snow"
              modules={modules}
              value={message}
              onChange={value => setMessage(value)}
              readOnly={loading || props.isBlocked}
            />
          </div>

          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: showPendencyFields ? 'space-between' : 'flex-end',
              gap: 20,
              width: '100%'
            }}
          >
            {showPendencyFields && (
              <ClaimFollowUpPendencyFields
                values={pendency}
                disabled={loading || props.isBlocked}
                onChange={setPendency}
              />
            )}
            <div>
              <Button
                primary
                content="Enviar"
                labelPosition={props.hideSendIcon ? undefined : 'right'}
                icon={props.hideSendIcon ? undefined : 'send'}
                style={props.hideSendIcon ? { minWidth: 136, textAlign: 'center' } : undefined}
                onClick={handleSubmit}
                loading={loading}
                disabled={loading || props.isBlocked}
              />
            </div>
          </div>
        </MessageContainer>
      )}

      {tempMessages.length > 0 ? (
        <MessageList messages={tempMessages} accentColor={accentColor} />
      ) : (
        <span style={{ paddingLeft: '40px' }}>Ainda sem mensagens neste Follow Up</span>
      )}
    </>
  );
};

export default MessageSender;
